import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Form, Row, Col, Table, Button, Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import moment from "moment";
import { get, isEmpty, some } from "lodash";
import { OrderDetailStatus } from "./store/constants";
import config from "../../config.js";
import { fileDowload } from "./store/sagas.js";
import RepairOrderDetail from "./components/RepairOrderDetail.js";

import(/* webpackChunkName: "orderDetail" */ "./orderDetail.scss");

const OrderDetail = ({
  loadOrderDetail,
  loadCheckboxSettings,
  fileDownload,
  orderDetailStatus,
  orderDetailData,
  profileData,
  checkboxSettingsData,
}) => {
  const { orderId } = useParams();
  const [purchaseOrderNumber, setPurchaseOrderNumber] = useState("");
  const [orderItems, setOrderItems] = useState([]);
  const [orderDate, setOrderDate] = useState("");
  const [requiredByDate, setRequiredByDate] = useState("");
  const [clientName, setClientName] = useState("");
  const [fitterName, setFitterName] = useState("");
  const [siteName, setSiteName] = useState("");

  const [promotionName, setPromotionName] = useState("");
  const [promotionOfferDescription, setPromotionOfferDescription] = useState("");
  const [promotionId, setPromotionId] = useState("");
  const [promotionOfferId, setPromotionOfferId] = useState("");

  const [orderType, setOrderType] = useState("");
  const [status, setStatus] = useState();
  const [statusDate, setStatusDate] = useState();
  const [statusNotes, setStatusNotes] = useState();
  const [files, setFiles] = useState([]);

  const [modalShow, setModalShow] = useState(false);
  const [modalData, setModalData] = useState({});

  const [showOrderDetailsSection, setShowOrderDetailsSection] = useState(false);

  // const [additionalInformationCheckbox, setAdditionalInformationCheckbox] =
  //   useState();
  // const [specialInstructionsCheckbox, setSpecialInstructionsCheckbox] =
  //   useState();

  const [isVirtualCare, setIsVirtualCare] = useState("");
  const [
    isForUseWithInvoicedHearingAidChecked,
    setIsForUseWithInvoicedHearingAidChecked,
  ] = useState(false);

  const [additionalInformationCheckbox, setAdditionalInformationCheckbox] =
    useState([]);
  const [additionalInformation, setAdditionalInformation] = useState("");

  const [checkboxList, setCheckboxList] = useState([]);
  const [checkboxListUpdated, setCheckboxListUpdated] = useState(false);

  useEffect(() => {
    if (loadCheckboxSettings) {
      loadCheckboxSettings();
    }
  }, [loadCheckboxSettings]);

  useEffect(() => {
    if (checkboxSettingsData && checkboxSettingsData.includes("{")) {
      //set checkbox list
      let splitCheckboxData = checkboxSettingsData
        .replace("{", "")
        .replace("}", "")
        .split(",");
      splitCheckboxData = splitCheckboxData.map((item) => item.trim());
      setCheckboxList(splitCheckboxData);
      setCheckboxListUpdated(true);
    }
  }, [checkboxSettingsData]);

  useEffect(() => {
    if (loadOrderDetail) {
      loadOrderDetail(orderId);
    }
  }, [loadOrderDetail]);

  useEffect(() => {
    if (orderDetailData) {
      // console.log("orderDetailData", orderDetailData);

      const tempOrderItems = get(orderDetailData, "OrderItems", []);
      console.log("tempOrderItems", tempOrderItems);
      setOrderItems(tempOrderItems);
      setPurchaseOrderNumber(orderDetailData.Ponumber);
      setOrderDate(orderDetailData.OrderDate);
      setRequiredByDate(orderDetailData.RequiredByDate);
      setClientName(orderDetailData.ClientFullName);
      setFitterName(orderDetailData.FitterName);
      setSiteName(orderDetailData.SiteName);

      setStatus(orderDetailData.Status);
      setStatusDate(orderDetailData.StatusDate);
      setStatusNotes(orderDetailData.StatusNotes);
      setOrderType(orderDetailData.OrderType);

      setPromotionName(orderDetailData.DiscountCode);
      setPromotionOfferDescription(orderDetailData.DiscountOption);
      setPromotionId(orderDetailData.PromotionId);
      setPromotionOfferId(orderDetailData.PromotionOfferId);

      setIsVirtualCare(orderDetailData.IsVirtualCare);
      setIsForUseWithInvoicedHearingAidChecked(
        orderDetailData.ForUseWithInvoicedHearingAid,
      );
      setAdditionalInformation(orderDetailData.SpecialInstructions);
      setAdditionalInformationCheckbox(
        orderDetailData.SpecialInstructionsCheckbox,
      );

      // setAdditionalInformationCheckbox(
      //   orderDetailData.AdditionalInformationCheckbox
      // );
      // setSpecialInstructionsCheckbox(
      //   orderDetailData.SpecialInstructionsCheckbox
      // );

      setFiles(orderDetailData.Files);
    }
  }, [orderDetailData]);

  useEffect(() => {
    const hasValues = some(orderItems, (item) => {
      return item.ConfigurationGroup != null || item.CustomOptions != null;
    });

    if (hasValues) {
      setShowOrderDetailsSection(true);
    }
  }, [orderItems]);

  if (orderDetailStatus === OrderDetailStatus.LOADING) {
    return (
      <Col>
        <div className="">
          <Loading />
        </div>
      </Col>
    );
  }

  const startPrint = () => {
    //console.log("PRINT")
    window.print();
    return false;
  };

  // const ProductDetailModal = (props) => {
  //   //console.log("modalData", modalData);
  //   let configGroup = {};
  //   let customOptions = {};
  //   if(modalData.ConfigurationGroup) {
  //     configGroup = JSON.parse(modalData.ConfigurationGroup);
  //   }
  //   if(modalData.CustomOptions) {
  //     customOptions = JSON.parse(modalData.CustomOptions);
  //   }
  //   const productDetails = {
  //     ...configGroup,
  //     ...customOptions
  //   };
  //   //("productDetails", productDetails);
  //   return (
  //     <Modal
  //       {...props}
  //       size="lg"
  //       aria-labelledby="contained-modal-title-vcenter"
  //       centered
  //     >
  //       <Modal.Header closeButton>
  //         <Modal.Title id="contained-modal-title-vcenter">
  //         {modalData.ItemName} {modalData.Side}
  //         </Modal.Title>
  //       </Modal.Header>
  //       <Modal.Body>
  //         <h4>Product Summary</h4>
  //         <table>
  //           <tr>
  //               <th>Special Instructions</th>
  //               <td>{modalData.SpecialInstructions}</td>
  //           </tr>
  //         {Object.entries(productDetails).map(([key, value]) => {
  //           if (value === "" || value === null) {
  //               return null;
  //           }
  //           return (
  //               <tr key={key}>
  //                   <th>{key}</th>
  //                   <td>{value}</td>
  //               </tr>
  //           )}
  //         )}
  //         </table>
  //       </Modal.Body>
  //       <Modal.Footer>
  //         <Button onClick={props.onHide}>Close</Button>
  //       </Modal.Footer>
  //     </Modal>
  //   );
  // }

  return (
    <div className="orderDetail-title">
      <div className="order-info">
        <Row>
          <Col>
            <h1>Order info</h1>
          </Col>
          <Col>
            <button
              onClick={startPrint}
              className="notprintable float-right btn btn-primary"
            >
              Print
            </button>
          </Col>
        </Row>
        <table>
          <tr>
            <th className="address-header">Address</th>
            <td>
              {config.siteName &&
                config.siteName === "UNITRON" &&
                "Unitron New Zealand"}
              {config.siteName &&
                config.siteName === "PHONAK" &&
                "Phonak New Zealand"}
              <br />
              Level 2, The Chester Building
              <br />
              28 The Warehouse Way
              <br />
              Northcote
              <br />
              Auckland 0627
            </td>
          </tr>
          <tr>
            <th>Order Number</th>
            <td>{orderId}</td>
          </tr>
          <tr>
            <th>Order Date</th>
            <td>{moment(orderDate).format("MMMM Do YYYY, h:mm a")}</td>
          </tr>
          {requiredByDate && requiredByDate.trim() !== "" && (
            <tr>
              <th>Required by Date</th>
              <td>{moment(requiredByDate).format("MMMM Do YYYY")}</td>
            </tr>
          )}
          <tr>
            <th>Client's Name</th>
            <td>{clientName}</td>
          </tr>
          <tr>
            <th>Fitter Name</th>
            <td>{fitterName}</td>
          </tr>
          <tr>
            <th>Clinic</th>
            <td>{profileData.OrganisationName}</td>
          </tr>
          <tr>
            <th>Site</th>
            <td>{siteName}</td>
          </tr>
        </table>
      </div>
      <div className="order-history">
        <h2>Order Summary</h2>
        <hr />
        <div>
          <table>
            <tr>
              <th>ITEMS FOR:</th>
              <td>
                {profileData && profileData.FirstName}{" "}
                {profileData && profileData.LastName}
              </td>
            </tr>
            {status && (
              <tr>
                <th>Order Status:</th>
                <td>{status}</td>
              </tr>
            )}
            {statusDate && (
              <tr>
                <th>Status Date:</th>
                <td>{moment(statusDate).format("MMMM Do YYYY, h:mm a")}</td>
              </tr>
            )}
            {statusNotes && (
              <tr>
                <th>Status Notes:</th>
                <td>{statusNotes}</td>
              </tr>
            )}
            {orderType && (
              <tr>
                <th>Order Type:</th>
                <td>{orderType}</td>
              </tr>
            )}
            {purchaseOrderNumber && (
              <tr>
                <th>Purchase Order #</th>
                <td>{purchaseOrderNumber}</td>
              </tr>
            )}
            {promotionName && (
              <>
                <tr>
                  <th>Promotion Id:</th>
                  <td>{promotionId}</td>
                </tr>
                <tr>
                  <th>Promotion Name:</th>
                  <td>{promotionName}</td>
                </tr>
              </>
            )}
            {promotionOfferDescription && (
              <>
                <tr>
                  <th>Promotion Offer Id:</th>
                  <td>{promotionOfferId}</td>
                </tr>
                <tr>
                  <th>Promotion Offer Description:</th>
                  <td>{promotionOfferDescription}</td>
                </tr>
              </>
            )}
            {isVirtualCare &&
              profileData &&
              profileData.OrganisationName.includes("Triton") && (
                <tr>
                  <th>Virtual Care:</th>
                  <td>
                    <div className="col-12 checkbox">
                      <input
                        type="checkbox"
                        id="virtualCare"
                        checked={isVirtualCare}
                        readOnly
                      />
                    </div>
                  </td>
                </tr>
              )}
            {isForUseWithInvoicedHearingAidChecked && profileData && (
              <tr>
                <th>For use with H.Aid(s) Invoiced in last 3 Mo:</th>
                <td>
                  <div className="col-12 checkbox">
                    <input
                      type="checkbox"
                      id="forUseWithInvoicedHearingAid"
                      checked={isForUseWithInvoicedHearingAidChecked}
                      readOnly
                    />
                  </div>
                </td>
              </tr>
            )}
            {/* {additionalInformationCheckbox
              ? checkboxList.map((checkbox, index) => {
                  let checkboxId = checkbox.trim();
                  let additionalInformationCheckboxChecked = new Array(
                    checkboxList.length
                  ).fill(false);
                  if (additionalInformationCheckbox) {
                    const parsedCheckboxes = additionalInformationCheckbox.split(",").map(value => {
                      return value.trim().toLowerCase() === "true";
                    });

                    console.log("parsedCheckboxes", parsedCheckboxes);

                    // Ensure the length matches checkboxList
                    additionalInformationCheckboxChecked = new Array(
                      checkboxList.length
                    )
                      .fill(false)
                      .map((_, index) => parsedCheckboxes[index] ?? false);
                    console.log(
                      "additionalInformationCheckboxChecked",
                      additionalInformationCheckboxChecked
                    );
                  }
                  return (
                    <td>
                    <div className="col-12 checkbox">
                      <input
                        type="checkbox"
                        id={checkboxId}
                        checked={
                          additionalInformationCheckboxChecked[index] || false
                        }
                        readOnly
                        />
                      <label htmlFor={checkboxId}>{checkbox}</label>
                    </div>
                        </td>
                  );
                })
              : ""} */}
            {additionalInformationCheckbox && (
              <tr>
                <th>Additional information:</th>
                <td>
                  <div className="col-12">
                    {checkboxList.map((checkbox, index) => {
                      let checkboxId = checkbox.trim();
                      let additionalInformationCheckboxChecked = new Array(
                        checkboxList.length,
                      ).fill(false);

                      if (additionalInformationCheckbox) {
                        const parsedCheckboxes = additionalInformationCheckbox
                          .split(",")
                          .map(
                            (value) => value.trim().toLowerCase() === "true",
                          );

                        // Ensure the length matches checkboxList
                        additionalInformationCheckboxChecked = new Array(
                          checkboxList.length,
                        )
                          .fill(false)
                          .map((_, index) => parsedCheckboxes[index] ?? false);
                      }

                      if (checkboxId === "Other" && additionalInformation) {
                        return (
                          <div className="checkbox" key={checkboxId}>
                            <input
                              type="checkbox"
                              id={checkboxId}
                              checked={
                                additionalInformationCheckboxChecked[index] ||
                                false
                              }
                              readOnly
                            />
                            <label htmlFor={checkboxId}>
                              {checkbox}: {additionalInformation}
                            </label>
                          </div>
                        );
                      }
                      return (
                        <div className="checkbox" key={checkboxId}>
                          <input
                            type="checkbox"
                            id={checkboxId}
                            checked={
                              additionalInformationCheckboxChecked[index] ||
                              false
                            }
                            readOnly
                          />
                          <label htmlFor={checkboxId}>{checkbox}</label>
                        </div>
                      );
                    })}
                  </div>
                </td>
              </tr>
            )}
            {/* {additionalInformation && (
              <tr>
                <th>Additional Information:</th>
                <td>{additionalInformation}</td>
              </tr>
            )} */}
            {files && files.length > 0 && (
              <tr>
                <th>Files:</th>
                <td>
                  <p>
                    {files.map((file) => {
                      return (
                        <span>
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              fileDownload(orderId, file);
                            }}
                            href="#"
                          >
                            {file}
                          </a>
                          ,{" "}
                        </span>
                      );
                    })}
                  </p>
                </td>
              </tr>
            )}
          </table>
        </div>
        <br />
        <Row>
          <Col xs={12}>
            {/* {orderItems &&
          orderItems.map((orderItem, index) => {
            return (
              <Col key={index} md={6} xs={12}>
                <div>
                  <p>{orderItem.Name}</p>
                  <p>Item Code: {orderItem.ItemCode}</p>
                  <p>Colour: {orderItem.ColourCode}</p>
                </div>
              </Col>
            );
          })} */}
            {orderItems && (
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Product Code</th>
                    <th>Quantity</th>
                    {/* <th>Item Details</th> */}
                  </tr>
                </thead>
                <tbody>
                  {orderItems.map((orderItem, index) => {
                    return (
                      <tr key={index}>
                        <th>
                          {orderItem.ItemName} {orderItem.Side}
                        </th>
                        <td>{orderItem.ItemCode}</td>
                        <td>
                          {orderItem.Quantity ? `${orderItem.Quantity}` : "1"}
                        </td>
                        {/* <td>
                          <Button variant="primary" onClick={() => {
                            setModalData(orderItem)
                            setModalShow(true)
                          }}>
                            See Item Details
                          </Button>
                        </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
            {orderType &&
              (orderType == "RepairRemake" ||
                orderType.includes("Repair") ||
                orderType.includes("ReshellRemake") ||
                orderType.includes("RemoteRicReceiverReplacement")) && (
                <div>
                  <h2>Submitted Repair / Remake Form</h2>
                  <hr />
                  <RepairOrderDetail
                    data={orderDetailData}
                    checkboxSettingsData={checkboxSettingsData}
                  />
                </div>
              )}
          </Col>

          {showOrderDetailsSection && (
            <Col xs={12}>
              <h2>Order Detail</h2>
              <hr />
              {orderItems &&
                orderItems.map((orderItem, index) => {
                  if (
                    orderItem.ConfigurationGroup == null &&
                    orderItems.CustomOptions == null
                  ) {
                    return;
                  }
                  let configGroup = {};
                  let customOptions = {};
                  let presetName = "";
                  if (orderItem.ConfigurationGroup) {
                    configGroup = JSON.parse(orderItem.ConfigurationGroup);
                  }
                  if (orderItem.CustomOptions) {
                    customOptions = JSON.parse(orderItem.CustomOptions);
                  }
                  if (orderItem.PresetName) {
                    presetName = orderItem.PresetName;
                  }
                  const productDetails = {
                    PresetName: presetName,
                    ...configGroup,
                    ...customOptions,
                  };
                  return (
                    <div>
                      <Row>
                        <Col xs={3}>
                          <h3>
                            {orderItem.ItemName} {orderItem.Side}:
                          </h3>
                        </Col>
                        <Col xs={9}>
                          {Object.entries(productDetails).map(
                            ([key, value]) => {
                              if (value === "" || value === null) {
                                return null;
                              }
                              return (
                                <div key={key}>
                                  <p>
                                    <strong>{key}</strong>: {value}
                                  </p>
                                </div>
                              );
                            },
                          )}
                          <p>
                            <strong>Special Instructions</strong>:{" "}
                            {checkboxListUpdated
                              ? checkboxList.map((checkbox, index) => {
                                  let checkboxId = checkbox.trim();
                                  let specialInstructionsCheckboxChecked =
                                    new Array(checkboxList.length).fill(false);
                                  if (orderItem.SpecialInstructionsCheckbox) {
                                    const parsedCheckboxes = JSON.parse(
                                      orderItem.SpecialInstructionsCheckbox,
                                    );

                                    // Ensure the length matches checkboxList
                                    specialInstructionsCheckboxChecked =
                                      new Array(checkboxList.length)
                                        .fill(false)
                                        .map(
                                          (_, index) =>
                                            parsedCheckboxes[index] ?? false,
                                        );
                                  }
                                  return (
                                    <div className="col-12 checkbox">
                                      <input
                                        type="checkbox"
                                        id={checkboxId}
                                        checked={
                                          specialInstructionsCheckboxChecked[
                                            index
                                          ] || false
                                        }
                                        readOnly
                                      />
                                      <label htmlFor={checkboxId}>
                                        {checkbox}
                                      </label>
                                    </div>
                                  );
                                })
                              : ""}
                          </p>
                          {orderItem.SpecialInstructions && (
                            <p>
                              <strong>Special Instructions</strong>:{" "}
                              {orderItem.SpecialInstructions}
                            </p>
                          )}
                        </Col>
                      </Row>
                      <hr />
                    </div>
                  );
                })}
            </Col>
          )}
        </Row>
      </div>
      {/* <ProductDetailModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      /> */}
    </div>
  );
};

OrderDetail.propTypes = {
  loadOrderDetail: PropTypes.func,
  fileDowload: PropTypes.func,
  orderDetailStatus: PropTypes.string,
  orderDetailData: PropTypes.object,
  profileData: PropTypes.object,
};

export default OrderDetail;
